import { useMediaQuery, useTheme } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledMockupImage,
  StyledMockupImageContainer,
  StyledWideImage,
} from '../../uiux/styles';
import type { HeroProps } from './Hero.types';
import {
  StyledContent,
  StyledTextContainer,
  StyledTitle,
  StyledDescription,
} from './styles';

export const Hero = ({
  title,
  subtitle,
  slug,
  image,
  mobileImage,
  useMockupImage,
}: HeroProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Section width="normal">
        <StyledContent>
          <StyledTextContainer>
            <StyledTitle variant="display_sm">{title}</StyledTitle>
            <StyledDescription variant="regular_500">
              {subtitle}
            </StyledDescription>
          </StyledTextContainer>
          {!isMobile && (
            <>
              {useMockupImage ? (
                <StyledMockupImageContainer>
                  <StyledMockupImage
                    unselectable="off"
                    draggable="false"
                    sx={{
                      borderRadius: '1.5rem',
                    }}
                    src={image}
                    alt={slug + 'CaseStudyMockupImage'}
                  />
                </StyledMockupImageContainer>
              ) : (
                <StyledWideImage
                  unselectable="off"
                  draggable="false"
                  sx={{
                    borderRadius: '1.5rem',
                  }}
                  src={image}
                  alt={slug + 'CaseStudyWideImage'}
                />
              )}
            </>
          )}
        </StyledContent>
      </Section>
      {isMobile && (
        <>
          {useMockupImage ? (
            <StyledMockupImageContainer>
              <StyledMockupImage
                unselectable="off"
                draggable="false"
                src={mobileImage ? mobileImage : image}
                alt={slug + 'CaseStudyMockupImage'}
              />
            </StyledMockupImageContainer>
          ) : (
            <StyledWideImage
              unselectable="off"
              draggable="false"
              src={mobileImage ? mobileImage : image}
              alt={slug + 'CaseStudyWideImage'}
            />
          )}
        </>
      )}
    </>
  );
};
